import React, { Component } from 'react';
import {Modal} from "antd-mobile";
import axios from "axios";
import storage from "../model/storage";
import Single from "./Single";
import Multi from "./Multi";
import Topic from "./Topic";
import Completion from "./Completion";
import Answersheet from "./Answersheet";
import globalSubscribe from "../common/globalState";
import "../assects/css/home.css";


class GF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      examId:"",
      paperId:"",
      userId:"",
      isDid:false,
      isShow:false,
      imgSrc:""
    };
  }
  componentWillMount(){
    if(this.props.location.state&&this.props.location.state.examId){
      
    }else{
      this.props.history.replace(`/?examId=${storage.get("examId")}&paperId=${storage.get("paperId")}&market=${storage.get("market")}`);
      window.location.reload();
    }
    document.title="考试估分|在线估分_山香教育|招教网";
    
  }
  componentDidMount(){
    
    let that = this;
    that.child.randerCard();
    if(this.props.location.state&&this.props.location.state.isDid===true){
      //console.log(that.props);
      this.setState({
        isDid:that.props.location.state.isDid,
        examId: that.props.location.state.examId,
          paperId: that.props.location.state.paperId,
          userId:that.props.location.state.userId
      })
      axios.get(storage.baseUrl+'/showPaper', {
        params: {
          examId: that.props.location.state.examId,
          paperId: that.props.location.state.paperId,
          userId:that.props.location.state.userId

        }
      })
        .then(function (response) {
          // handle success
          //console.log(response);
          //console.log(response.data);
          let questionDates=response.data.questionDatas;
         
          //console.log(response.data);
          that.setState({
            questionDates:questionDates
          })
         
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })

    }else{
      
      axios.get(storage.baseUrl+'/composePaper', {
        params: {
          examId: that.props.location.state.examId,
          paperId: that.props.location.state.paperId,
          userId:that.props.location.state.userId
        }
      })
        .then(function (response) {
          // handle success
          //console.log(response.data);
          let questionDates=response.data.questionDates;
         
          //console.log(response.data);
          that.setState({
            questionDates:questionDates
          })
         
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
       
    }
    
  }
  
    
  

  componentDidUpdate(){
    this.child.randerCard();
  }
  
  onRef = (ref) => {

    this.child = ref

}
  subCard=(questionId,optChoose,correctness,score,questionType)=>{
    console.log(questionId,optChoose,correctness,score,questionType,'eeeeeeee')
    if(this.props.location.state&&this.props.location.state.isDid===true){
      return false;
    }else{
      var that = this;
      // axios.get(storage.baseUrl+'/updateAnswerCard', {
      //   params: {
      //     paperId: that.props.location.state.paperId,
      //     questionId: questionId,
      //     userId:that.props.location.state.userId,
      //     optChoose:optChoose.replace(/\n/gm, '').replace(/\s+/g,''),
      //     correctness:correctness,
      //     score:score
      //   }
      // })
      //   .then(function (response) {
         
      //  //console.log(response);
         
      //   })
      //   .catch(function (error) {
      //     // handle error
      //     console.log(error);
      //   })
      let obj = {}
      obj = {
        paperId: that.props.location.state.paperId,
        questionId: questionId,
        userId:that.props.location.state.userId,
        optChoose:optChoose,
        correctness:correctness,
        score:score,
        status:optChoose&&optChoose!=''?'1':'0',
        questionType:questionType
      }
      // console.log(obj,'obj')
      const { arr } = globalSubscribe.getState();
      const newArr = [...arr];
      const currentIndex = newArr.findIndex(o => o.questionId == obj.questionId);
      if(currentIndex > -1) {
        newArr.splice(currentIndex, 1)
      }
      // if(obj.optChoose != "" && obj.optChoose != undefined) {
        newArr.push(obj)
      // }
      globalSubscribe.setArr(newArr);
      // console.log(globalSubscribe.getState().arr)
    }
    
  }
  onClose =() => {
    this.setState({
     imgShow: false
    });
  }
 imgShow=(e)=>{
  //console.log(e);
  if(e.target.nodeName==="IMG"){
    this.setState({
      imgShow:true,
      imgSrc:e.target.src
    })
  }
 }
  render() {
   const {isDid}=this.state
    return (
      <div>
          <Modal
          className="imgCon"
            visible={this.state.imgShow}
            transparent
            maskClosable={true}
            onClose={this.onClose}
            title="查看图片"
            footer={[{ text: 'Ok', onPress: () => { console.log('ok'); this.onClose();} }]}
            wrapProps={{ onTouchStart: this.onWrapTouchStart }}
            
          >
          <img style={{width:'100%'}} src={this.state.imgSrc} alt="" />
          </Modal>
      
      <div className="gf_con" >
          <p className="gf_T">注意事项：本试卷来自考生回忆，不对真实性负责，仅供参考</p>
         <div className="qus_con">
           {
             this.state.questionDates&&this.state.questionDates.map((value,key)=>{
               if(value.questionType==="1001"){
                 return(
                  <Single  data={[value]} ansShow={true}   key={key} Skey={key+1} subCard={this.subCard} imgShow={this.imgShow} title='单项选择题' listXX="单选" isDid={isDid}></Single>
                 )
               }else if(value.questionType==="1002"){
                return(
                <Multi data={[value]} key={key} ansShow={true} Skey={key+1} subCard={this.subCard} imgShow={this.imgShow} title='多项选择题' listXX="多选" isDid={isDid}></Multi>
               
                )
              }else if(value.questionType==="1016"){
                return(
                <Multi data={[value]} key={key} ansShow={true} Skey={key+1} subCard={this.subCard} imgShow={this.imgShow} title='不定项选择题' listXX="不定项选择" isDid={isDid}></Multi>
               
                )
              }else if(value.questionType==="1003"){
                return(
                  <Single data={[value]}  ansShow={true} key={key} Skey={key+1}  subCard={this.subCard} imgShow={this.imgShow} title='判断题' isDan="1" listXX="判断" isDid={isDid}></Single>
               
                )
              }else if(value.questionType==="1013"){
                return(
                  <Completion data={[value]}  ansShow={true} key={key} Skey={key+1}  subCard={this.subCard} imgShow={this.imgShow} title='填空题'  listXX="填空" isDid={isDid}></Completion>
               
                )
              }
              else{
                return(
                  <Topic data={[value]}  ansShow={true} key={key} Skey={key+1}  subCard={this.subCard} imgShow={this.imgShow} title='主观题' listXX="综合"></Topic>
               
                )
              }
             })
           }
        {/* <Completion data={this.state.activeDesigns}  subCard={this.subCard} imgShow={this.imgShow} title='填空题' listXX="题型"></Completion>
         
           <Multi data={this.state.multiList}  subCard={this.subCard} imgShow={this.imgShow} title='多项选择题' listXX="题型"></Multi>
          <Single data={this.state.judgeList}  subCard={this.subCard} imgShow={this.imgShow} title='判断题' isDan="1" listXX="题型"></Single>
          <Topic data={this.state.shortList}  subCard={this.subCard} imgShow={this.imgShow} title='简答题' listXX="题型"></Topic>
          <Topic data={this.state.analysList} subCard={this.subCard} imgShow={this.imgShow} title='辨析题' listXX="题型"></Topic>
          <Topic data={this.state.materAnalys}  subCard={this.subCard} imgShow={this.imgShow} title='材料分析题' listXX="题型"></Topic>
          <Topic data={this.state.writings}  subCard={this.subCard} imgShow={this.imgShow} title='写作题' listXX="题型"></Topic>
          <Topic data={this.state.desingns}  subCard={this.subCard} imgShow={this.imgShow} title='教学设计题' listXX="题型"></Topic>
          <Topic data={this.state.caseAnalys}  subCard={this.subCard} imgShow={this.imgShow} title='案例分析题' listXX="题型"></Topic>
          <Topic data={this.state.nounExplains}  subCard={this.subCard} imgShow={this.imgShow} title='名词解释题' listXX="题型"></Topic>
          <Topic data={this.state.discussTypes}  subCard={this.subCard} imgShow={this.imgShow} title='论述题' listXX="题型"></Topic>
          <Topic data={this.state.activeDesigns}  subCard={this.subCard} imgShow={this.imgShow} title='活动设计题' listXX="题型"></Topic> */}
        
          </div>
      
      </div>
      <Answersheet examType="0" onRef={this.onRef} history={this.props.history} isDid={this.state.isDid} paperId={this.props.location.state.paperId} userId={this.props.location.state.userId} examId={this.props.location.state.examId}></Answersheet>
      </div>
    );
          
  }
}

export default GF;
